function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140 122V77.472c0-17.722 14.5-32.222 32.222-32.222h167.556c17.723 0 32.222 14.5 32.222 32.222V122M477 266v170.75c0 16.497-13.503 30-30 30H65c-16.497 0-30-13.5-30-30V267",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#868689",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 316.5c-105.789-6.049-201-36.3-201-90.753V154.75c0-16.523 13.476-30 30-30h422c16.523 0 30 13.478 30 30v70.997c0 54.794-96.414 85.082-203 90.864",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#868689",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 286.75h74v34.5c0 18.975-15.525 34.5-34.5 34.5h-5c-18.975 0-34.5-15.525-34.5-34.5v-34.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#868689",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.86d61309caf180ef12dc3f028144589a.svg";
export { ForwardRef as ReactComponent };